import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IPaymentFlowRestoreStore<TRestoreState = unknown> {
	/** Persistent part */
	restoreState: TRestoreState | null;
	isRestoring: boolean;
	/** *** */

	setRestoreData: (data: TRestoreState | null) => void;
	setIsRestoring: (isRestoring: boolean) => void;
	reset: () => void;
}

const initialState: Pick<
	IPaymentFlowRestoreStore,
	'restoreState' | 'isRestoring'
> = {
	restoreState: null,
	isRestoring: false,
};

export const usePaymentFlowRestoreStore = create<IPaymentFlowRestoreStore>()(
	persist(
		(set) => ({
			...initialState,

			setRestoreData: (data) =>
				set({
					restoreState: data,
				}),

			setIsRestoring: (restoring) => set({ isRestoring: restoring }),

			reset: () => set(initialState),
		}),
		{
			name: 'trueLayerRestore',
			/** Only persist specific fields, exclude callback */
			partialize: (state) => ({
				restoreState: state.restoreState,
			}),
		}
	)
);
